import { render, staticRenderFns } from "./mining-record.vue?vue&type=template&id=7e310396&scoped=true&"
import script from "./mining-record.vue?vue&type=script&lang=js&"
export * from "./mining-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e310396",
  null
  
)

export default component.exports